import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getIsInitialSpaRender } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';

const TRACE_ID_META_NAME = 'X-B3-TraceId';

/**
 * Returns the SSR request trace id (used as the taskStart `taskId`) so terminal
 * events can be correlated with the SSR `taskStart` event.
 *
 * Only returns a value when:
 * - the feature gate is enabled (kept in lockstep with the SSR emit gate), and
 * - this is the initial SSR-rendered page (not a SPA transition or embed).
 *
 * The trace id is read from the `X-B3-TraceId` meta tag rendered by SSR.
 */
export const getTaskId = (): string | undefined => {
	if (!fg('jfp-cmon-task-start-issue-view-gasv3')) {
		return undefined;
	}

	if (!getIsInitialSpaRender()) {
		return undefined;
	}

	return getMeta(TRACE_ID_META_NAME) ?? undefined;
};
